import { Link } from '@mui/material';

// import: styles
import Box from '@mui/material/Box';

// import: assets
import Img from 'core/assets/img/blocked-state/blocked-state.webp';
import BaseImage from 'core/components/image/BaseImage';
import BaseTypography from 'core/components/typography/BaseTypography';

// import: config
// import: constants
// import: utils
// import: services
// import: redux
// import: components
import Footer from 'core/layouts/components/footer/Footer';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import { blockedStateStyles } from 'core/navigation/blocked-state/BlockedStateStyles';
import React from 'react';

// import: lazy load components

function BlockedState() {
	return (
		<Box id="blocked-page" sx={[reusableStyles.pageWithoutTabsHeader]}>
			<Box id="blocked-page-fold" sx={[reusableStyles.fold, reusableStyles.foldWithoutTabsHeader]}>
				<Box
					id="blocked-page-content"
					sx={[reusableStyles.contentWithoutTabsHeader, blockedStateStyles.content]}
				>
					<Box sx={blockedStateStyles.imgCont}>
						<BaseImage src={Img} alt="" />
					</Box>
					<BaseTypography variant="h2_medium" styles={{ color: 'colors.light2' }}>
						Blocked
					</BaseTypography>
					<BaseTypography variant="b1_regular" styles={{ color: 'colors.light4' }}>
						Your account has been blocked due to guideline violations.
						<br /> We will manually review the account and reinstate within 30 mins if no serious
						violations are found or if this is a mistake. <br /> If you think this is a mistake,
						please contact us at{' '}
						<Link
							target="_top"
							rel="noopener noreferrer"
							href="mailto: hello@affogato.ai"
							sx={blockedStateStyles.link}
						>
							hello@affogato.ai
						</Link>
					</BaseTypography>
				</Box>
			</Box>

			<Footer />
		</Box>
	);
}

export default BlockedState;
